import React, { Component } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import PropTypes from 'prop-types'
import axios from "../axios";
import Alert from "react-s-alert";

class DataImportGagalModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            user_passw : '',
            isLoadingBu : false
        }

        this.toggleModalVerifikasi = this.toggleModalVerifikasi.bind(this)
        this.handleChangeMod = this.handleChangeMod.bind(this)
    }

    toggleModalVerifikasi() {
        this.props.toggleModalVerifikasi()
    }


    handleChangeMod(event) {

        const target = event.target;
        const value  = target.value;
        const name   = target.name;

        this.setState({
            [name]: value
        })
    }

    render() {
        return (
            <Modal isOpen={this.props.isShow} toggle={this.toggleModalVerifikasi} className="modal-primary custom-dialog">
                <ModalHeader toggle={this.toggleModalVerifikasi}>{this.props.modalHeaderText}</ModalHeader>
                <ModalBody>

                    {/* {this.props.dataGagal.length === 0 ? "Data Kosong..." : ( */}
                        <div className="form-group row">
                            <label className="col-lg-12 form-control-label">
                                {this.props.modalBodyText}
                            </label>
                            
                            {this.props.status_import =='1' ?
                                <table className="table table-striped table-bordered animated fadeIn">
                                    <thead>
                                        <tr>
                                            <th width="50">No</th>
                                            <th>Nisn</th>
                                            <th>Nama Siswa</th>
                                            <th>User Name</th>
                                            <th>Password</th>
                                            <th>Kelas</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                            <tr key={1}>
                                                <td>{1}</td>
                                                <td>{this.props.dataGagal.siswa_nisn == null ? 'Harap lengkapi data field ini !!!':this.props.dataGagal.siswa_nisn}</td>
                                                <td>{this.props.dataGagal.siswa_nama == null ? 'Harap lengkapi data field ini !!!':this.props.dataGagal.siswa_nama}</td>
                                                <td>{this.props.dataGagal.siswa_username == null ? 'Harap lengkapi data field ini !!!':this.props.dataGagal.siswa_username}</td>
                                                <td>{this.props.dataGagal.siswa_password == null ? 'Harap lengkapi data field ini !!!':this.props.dataGagal.siswa_password}</td>
                                                <td>{this.props.dataGagal.kelas_id == null ? 'Harap lengkapi data field ini !!!':this.props.dataGagal.kelas_id}</td>
                                            </tr>
                                    </tbody>
                                </table>
                            :
                            
                            <table className="table table-striped table-bordered animated fadeIn">
                                <thead>
                                    <tr>
                                        <th width="50">No</th>
                                        <th>Siswa ID</th>
                                        <th>Nama Siswa</th>
                                        <th>Nisn</th>
                                        <th>Kelas</th>
                                        <th>User Status</th>
                                        <th>RFID</th>
                                    </tr>
                                </thead>
                                <tbody>
                                        <tr key={1}>
                                            <td>{1}</td>
                                            <td>{this.props.dataGagal.siswa_id == null ? 'Harap lengkapi data field ini !!!':this.props.dataGagal.siswa_id}</td>
                                            <td>{this.props.dataGagal.user_nama == null ? 'Harap lengkapi data field ini !!!':this.props.dataGagal.user_nama}</td>
                                            <td>{this.props.dataGagal.siswa_nisn == null ? 'Harap lengkapi data field ini !!!':this.props.dataGagal.siswa_nisn}</td>
                                            <td>{this.props.dataGagal.kelas_nama == null ? 'Harap lengkapi data field ini !!!':this.props.dataGagal.kelas_nama}</td>
                                            <td>{this.props.dataGagal.user_status == null ? 'Harap lengkapi data field ini !!!':this.props.dataGagal.user_status}</td>
                                            <td>{this.props.dataGagal.siswa_rfid == null ? 'Harap lengkapi data field ini !!!':this.props.dataGagal.siswa_rfid}</td>
                                        </tr>
                                </tbody>
                            </table>
                            }
                        </div>
                    {/* )} */}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={this.toggleModalVerifikasi}>Batal</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

DataImportGagalModal.propTypes = {
    modalHeaderText: PropTypes.string.isRequired,
    modalBodyText: PropTypes.string.isRequired,
    modalSubmitText: PropTypes.string.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    toggleModalVerifikasi: PropTypes.func.isRequired,
    dataGagal: PropTypes.array.dataGagal,
    status_import: PropTypes.string.status_import
}

export default DataImportGagalModal


// WEBPACK FOOTER //
// ./src/components/DataImportGagalModal.js